import { useApiBase } from '../../base/api-base';
import { useCallback } from "react";
import { VariaveisAmbiente } from "config";

export function useGetDestinatariosExportarExcel() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getDestinatariosExportarExcel = useCallback(
        async (propagandaId: string, queryBusca?: string) => {
            const queryFinal = `${queryBusca && queryBusca.length > 0 ? "?" : ""}${queryBusca || ""}`;

            return invocarApi({
                url: `/v1/Propaganda/${propagandaId}/Destinatarios/excel${queryFinal}`,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                method: 'GET',
                enviarTokenUsuario: true,
                responseType: 'blob',
                timeout: 180000,
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    "Content-Disposition": "attachment; filename=destinatarios.xls; filename*=UTF-8''destinatarios.xls"
                },
            })
        },
        [invocarApi]);
    return {
        ...outrasPropriedades,
        getDestinatariosExportarExcel,
    }
}
